import { render, staticRenderFns } from "./RequirementAddEditImmediateActionRequirement.vue?vue&type=template&id=047017d8"
import script from "./RequirementAddEditImmediateActionRequirement.vue?vue&type=script&lang=js"
export * from "./RequirementAddEditImmediateActionRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports